export default "__VITE_ASSET__BWywElvb__"